import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "country-select row" }
const _hoisted_2 = { class: "col-xs-12 col-sm-6 col-md-12 col-lg-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, " Nazione: ", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "col-xs-12 col-sm-6 col-md-12 col-lg-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, " Regione: ", -1)
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("select", {
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChangeCountry && _ctx.onChangeCountry(...args))),
        class: "form-control text-uppercase"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (c) => {
          return (_openBlock(), _createElementBlock("option", {
            key: 'country-select-' + c.id,
            value: c.isoCode
          }, _toDisplayString(c.name), 9, _hoisted_4))
        }), 128))
      ], 32)
    ]),
    (_ctx.isItalian)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("select", {
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeRegion && _ctx.onChangeRegion(...args))),
            class: "form-control text-uppercase"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (c) => {
              return (_openBlock(), _createElementBlock("option", {
                key: 'country-select-' + c.id,
                value: c.id
              }, _toDisplayString(c.name), 9, _hoisted_7))
            }), 128))
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}